import { computed, ComputedRef } from 'vue';
import axios from 'axios';
import { useResultsStore } from '@/storePinia/stores/results';
import useLoader from '@use/useLoader/useLoader';
import { ICurrency } from '@/storePinia/stores/results/IResults';

const resultsStore = useResultsStore();
const loader = useLoader();

interface IUseCurrencies {
  currencyList: ComputedRef<Partial<ICurrency[]> | undefined>;
  selectedCurrency: ComputedRef<ICurrency | undefined>;
  changeCurrency: (currency: ICurrency) => Promise<void>;
}

type ISelectedCurrency = {
  path: string;
  action: string;
  LANGUAGE_ID: string;
  currencyId: number;
  siteCode: string;
};

export default function useCurrencies(): IUseCurrencies {
  const siteSettings = computed(() => resultsStore.siteSettings);
  const currencyList = computed(() => resultsStore.siteCurrencies);
  const selectedCurrency = computed(() =>
    resultsStore.siteCurrencies?.find((el): el is ICurrency => !!el && el.active)
  );
  const setUserSiteCurrency: ComputedRef<ISelectedCurrency | undefined> = computed(
    () => resultsStore.routes?.siteCurrency?.setUserSiteCurrency
  );

  const changeCurrency = async (currency: ICurrency): Promise<void> => {
    try {
      if (setUserSiteCurrency.value) {
        loader.start();
        const { path, action } = setUserSiteCurrency.value;
        const response = await axios.post(path, {
          action,
          siteCode: siteSettings?.value?.siteCode,
          currencyId: currency.ID,
        });

        if (response.status === 200) {
          window.location.reload();
        }
      }
    } catch (err) {
      console.error(err);
      loader.stop();
    }
  };

  return {
    currencyList,
    selectedCurrency,
    changeCurrency,
  };
}
